// src/utils/quote/leftoverEstimate.js
// Request-time estimate of unpumpable surplus concrete (ylijäämä) — the amount
// that stays in the equipment and never reaches the pour. Ordered volume is
// always larger than the pour needs by this residual (plus the 0.5 m³ round-up),
// and the surplus stays on the worksite or goes to recycling for a fee.
//
// EXACT PORT of puminet4/src/data/pumppuClass.js getters `ylijaamaBetoniPuomi`
// and `ylijaamaBetoniLinja` — keep in lock-step with that source so Jerry and
// betoni.online never disagree. betonijerry is standalone (no @ibetoni/* deps),
// so the logic is duplicated locally rather than shared (same self-contained
// pattern as KeikkaPumpIcon). Inputs are lengths in metres.

/**
 * Boom residual (litres). Mirror of `ylijaamaBetoniPuomi`. Wider pipe than a
 * line + the truck's internal run, with a hard 150 L floor. Caller applies this
 * only when the boom length is > 0.
 */
export function boomLeftoverLitres(puomiM) {
    const autonPituus = 13; // truck internal length adds to the pipe run
    let d = 4; // inches
    if (puomiM > 33) d = 5;
    const r = (d / 2) * 2.5; // cm
    return Math.max(150, Math.ceil(((puomiM + autonPituus) * Math.PI * r * r) / 500) * 50);
}

/**
 * Line residual (litres). Mirror of `ylijaamaBetoniLinja`. Narrower pipe that
 * widens with length. Caller applies this only when the line length is > 0.
 */
export function lineLeftoverLitres(linjaM) {
    const linja = Math.round(linjaM / 10) * 10;
    let d = 2; // inches
    if (linjaM > 70) d = 3;
    else if (linjaM > 20) d = 2 + (linjaM - 20) / 50;
    const r = (d / 2) * 2.5; // cm
    return Math.ceil((linja * Math.PI * r * r) / 100) * 10;
}

/**
 * Combined residual from the draft's pump fields (string metres). `0`/empty/
 * non-numeric contribute nothing. Boom + separate extension line sum.
 * @returns {{ boom: number, line: number, total: number }} litres
 */
export function estimateLeftoverLitres({ puomi, linjanPituus } = {}) {
    const p = Number(puomi);
    const l = Number(linjanPituus);
    const boom = Number.isFinite(p) && p > 0 ? boomLeftoverLitres(p) : 0;
    const line = Number.isFinite(l) && l > 0 ? lineLeftoverLitres(l) : 0;
    return { boom, line, total: boom + line };
}
